"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.checkAuth = void 0;
var _lifeCycleActions = require("../actions/lifeCycleActions");
var _userActions = require("../actions/userActions");
var _apiKeyActions = require("../actions/apiKeyActions");
var _affiliateActions = require("../actions/affiliateActions");
var _reportActions = require("../actions/reportActions");
var _wsConnectionActions = require("../actions/wsConnectionActions");
var _authActions = require("../actions/authActions");
var _appActions = require("../actions/appActions");
var _apiActions = require("../actions/apiActions");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// Track if we're in a user-initiated logout to prevent reload on server LogoutEvent
var isUserInitiatedLogout = false;
var authMiddleware = function authMiddleware(store) {
  return function (next) {
    return function (action) {
      var dispatch = store.dispatch;
      if (action.type === _authActions.AUTH_NONE) {
        isUserInitiatedLogout = true;
        onLogout(action);
        // Reset the flag after a short delay to allow the LogoutEvent to be ignored in the case of user-initiated logout
        setTimeout(function () {
          isUserInitiatedLogout = false;
        }, 1000);
      } else if (action.type === _authActions.AUTH_SUCCESS) {
        onLogin(dispatch, action);
      } else if (action.type === _lifeCycleActions.APP_INIT) {
        onAppInit(dispatch);
      } else if (action.type === _authActions.FORCED_LOGOUT) {
        onLogout(action, isUserInitiatedLogout);
      }
      return next(action);
    };
  };
};
var setOnConnectionChange = function setOnConnectionChange(dispatch) {
  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || navigator.msConnection;
  if (connection) {
    connection.onchange = function () {
      if (navigator.onLine) {
        dispatch((0, _wsConnectionActions.pingBackend)());
      }
    };
  }
};
var onAppInit = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(dispatch) {
    var token, auth;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          setOnConnectionChange(dispatch);
          dispatch((0, _authActions.subscribeToLogoutEvent)());
          token = localStorage.getItem('token');
          if (!token) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return dispatch((0, _authActions.validateSessionToken)(token));
        case 1:
          auth = _context.v;
          // validateSessionToken returns undefined when the token is rejected
          // (it dispatches logout instead) — e.g. after a gateway restart.
          if (auth && auth.SessionToken) {
            localStorage.setItem('token', auth.SessionToken);
          }
        case 2:
          // (!oldValue) If we are creating the token key in localStorage, we want to log in on any tabs
          // (!newValue) If we are removing the token key in localStorage, we want to log out on any tabs
          window.addEventListener('storage', function (event) {
            var key = event.key,
              oldValue = event.oldValue,
              newValue = event.newValue;
            if (key === 'token') {
              if (!newValue || !oldValue) {
                window.location.reload();
              }
            }
          });
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function onAppInit(_x) {
    return _ref.apply(this, arguments);
  };
}();
var onLogin = function onLogin(dispatch, action) {
  localStorage.setItem('token', action.payload.token);
  dispatch(initDataAfterLogin(action.payload.userId));
};
var onLogout = function onLogout(action) {
  var skipReload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  localStorage.removeItem('token');
  if (action.type === _authActions.FORCED_LOGOUT && !skipReload) {
    window.location.reload();
  }
};
var checkAuth = exports.checkAuth = function checkAuth(dispatch) {
  var token = localStorage.getItem('token');
  if (token) {
    dispatch((0, _authActions.validateSessionToken)(token));
  } else {
    dispatch((0, _authActions.logout)());
  }
};
var initDataAfterLogin = function initDataAfterLogin(userId) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(dispatch) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            dispatch((0, _apiActions.getApiInfo)());
            dispatch((0, _appActions.loadStartupData)());
            dispatch((0, _userActions.getUserInfo)(userId));
            dispatch((0, _apiKeyActions.getUserApiKeys)(userId));
            dispatch((0, _affiliateActions.getAffiliateCount)());
            dispatch((0, _reportActions.getUserReports)(userId));
            dispatch((0, _reportActions.getUserReportWriterResults)());
          case 1:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
var _default = exports["default"] = authMiddleware;